import { lazy, Suspense, useEffect, useState } from "react";
import FullPageLoader from "@/ui/fullPageLoader/FullPageLoader";
import { usePageTitle } from "@/i18n/usePageTitle";
import { useCurrentLanguage } from "@/i18n/useLocalized";
import BosnianViewNotice from "@/pages/legal/BosnianViewNotice";
import PrivacyPolicyBosnian from "./PrivacyPolicy.bs.jsx";

// Bosnian stays in the main bundle, as before; English loads only when read.
const PrivacyPolicyEnglish = lazy(() => import("./PrivacyPolicy.en.jsx"));

export default function PrivacyPolicy() {
	usePageTitle("seo:titles.privacy");
	const language = useCurrentLanguage();
	// "Read the Bosnian version" is a view choice for this page only, and it
	// ends when the language changes.
	const [showBosnian, setShowBosnian] = useState(false);
	useEffect(() => setShowBosnian(false), [language]);

	// Bosnian readers get the Bosnian page exactly as before, with no note.
	if (language !== "en") return <PrivacyPolicyBosnian />;

	if (showBosnian)
		return (
			<PrivacyPolicyBosnian
				notice={<BosnianViewNotice onReadEnglish={() => setShowBosnian(false)} />}
			/>
		);

	return (
		<Suspense fallback={<FullPageLoader />}>
			<PrivacyPolicyEnglish onReadBosnian={() => setShowBosnian(true)} />
		</Suspense>
	);
}
